import { Typography } from '@thingsw/pitta-design-system';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { THEME } from '../../features/Theme/slice';

interface SurveyContentProps {
  title: string;
  description: string;
  content: React.ReactNode;
}

const SurveyContent = ({ title, description, content }: SurveyContentProps) => {
  const { colors } = useSelector((state: RootState) => state[THEME]);

  return (
    <>
      <div
        style={{
          paddingLeft: 6,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          paddingBottom: 44,
        }}
      >
        <Typography htmlColor={colors.primary['1']} variant='H5'>
          {title}
        </Typography>
        <Typography htmlColor={colors.primary['2']} variant='BodyBold'>
          {description}
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          marginBottom: 84,
        }}
      >
        {content}
      </div>
    </>
  );
};

export default SurveyContent;
